import { css } from "@emotion/react";

import theme from "../../styles/theme";
import { blue, greyLight, greyF7, white } from "../../styles/variables";

export const dialog = css`
  .MuiDialog-paper {
    height: 86.7%;
  }
`;

export const section = css`
  display: flex;
  align-items: center;
`;

export const dialogTitle = css`
  flex: 1 1 auto;
  font-weight: bold;
  font-size: 18px;
`;

export const dialogActions = css`
  flex: 0 0 auto;
`;

export const btn = css`
  margin-left: ${theme.spacing(1.5)}px;
  padding: 12px;
  font-weight: bold;
`;

export const checkIcon = css`
  margin-right: ${theme.spacing(1)}px;
  width: 16px;
  height: 16px;
`;

export const dialogContentBlock = css`
  border-bottom-width: 0;
  border-top: 2px solid ${greyF7};

  .MuiTableContainer-root {
    box-shadow: none;
  }

  .MuiTableCell-root {
    border-width: 0;
  }

  .MuiTableBody-root {
    .MuiTableRow-root {
      background-color: ${greyF7};
    }

    .MuiTableCell-root {
      border-bottom: 8px solid ${white};
    }
  }
`;

export const contentHead = css`
  display: flex;
  flex: 1 1 auto;
  align-items: center;
`;

export const labelText = css`
  font-weight: bold;
`;

export const refreshButton = css`
  margin-left: 12px;
`;

export const refreshIcon = css`
  width: 16px;
  height: 16px;
  margin-right: ${theme.spacing(1)}px;
`;

export const searchBox = css`
  flex: 0 0 auto;
  width: 200px;
  border-radius: 4px;
  background-color: ${greyLight};

  .MuiInput-underline {
    padding: 12px;

    &::before {
      border-bottom-color: transparent;
    }

    &:hover:not(.Mui-disabled)::before {
      border-bottom-color: transparent;
    }
  }
`;

export const searchIcon = css`
  color: ${blue};
`;

export const emptySection = css`
  position: relative;
  height: 90%;
`;

export const emptyBox = css`
  position: absolute;
  height: 90%;
  top: 45%;
  transform: translateY(-45%);
  right: 0;
  left: 0;
`;
